import { Col, Flex, Form, Row,message } from "antd";
import React, { useState } from "react";
import { db } from "../../../api's/firebase";
import { ref, push } from "firebase/database";
import { sendContactSalesEmail } from "../../../api's/sendcontactemail";

// Components
import {
  CustomButton,
  CustomInput,
  CustomModal,
  CustomModalWithoutButton,
  CustomParagraph,
  CustomTitle,
} from "../../../components";

// Assets
import heroImg from "../../../assets/images/hero-img.png";
import heroImgSmall from "../../../assets/images/hero-img-sm.png";
import ThankYou from "./ThankYou";
import { useSpin } from "../../../components/SpinContext";

const Hero = () => {
  const [form] = Form.useForm();
  const [modalOpen, setModalOpen] = useState(false);
  const { showSpin, hideSpin } = useSpin();

  const openThankYouModal = () => {
    setModalOpen(true);
  };
  const onFinish = (values) => {
    console.log("Success:", values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleSubmit = async(values) => {
    showSpin();
    const newData = {
      name: values.name,
      email: values.email,
      company: values.companyName,
      isverified: false,
      signup: new Date().toISOString()
    };

    push(ref(db, "signup"), newData)
      .then((response) => {
        console.log(response)
        console.log("New data added to signup collection");

        form.resetFields();
        openThankYouModal();
      })
      .catch((error) => {
        console.error("Error adding new data: ", error);
      }).finally(() => {
        hideSpin();
    });


   

    const { success,message: resultMessage } = await sendContactSalesEmail({
          recipient: values?.email,
          name: values?.name,
          companyName: values?.companyName,
          message: values?.message || "No additional message provided.",
          earlysignup:true
    });

    if (success) {
      message.success(resultMessage);
    } else {
      message.error(resultMessage);
    }




  };

  const validateNoWhitespace = (_, value) => {
    if (!value || value.trim() === "") {
      return Promise.reject(new Error("This field cannot be empty or contain only whitespace"));
    }
    return Promise.resolve();
  };

  return (
    <>
      <div className="hero">
        <div className="hero-wrapper">
          <Row gutter={[0, 24]} align="" justify="end" className="hero-row">
            <Col xs={24} sm={24} lg={16} xl={8} className="hero-left">
              <div className="hero-left-content">
                <CustomTitle
                  text="Advanced Pharma supply chain visibility and intervention"
                  fontSize="44px"
                  fontWeight="900"
                  color="black"
                  lineHeight="52px"
                  marginBottom="24px"
                />
                <CustomParagraph
                  text="Track all shipments in one view, identify inefficiencies with real-time intelligence, take swift action to
prevent losses."
                  fontSize="18px"
                  fontWeight="400"
                  color="black"
                  lineHeight="28px"
                  marginBottom="40px"
                />
                <Form form={form}
                  name="basic"
                  layout="vertical"
                  onFinish={handleSubmit}
                  autoComplete="off"
                >
                  <Row gutter={[16, 24]}>
                    <Col xs={24} sm={24} md={12} lg={10} xl={10}>
                      <Form.Item
                        className="custom-input"
                        label="Your Name"
                        name="name"
                        rules={[
                          {
                            required: true,
                            message: "Please input your name",
                          },
                          {
                            validator: validateNoWhitespace,
                          },
                        ]}
                      >
                        <CustomInput
                          placeholder="First and last"
                          height="36px"
                          border="0px"
                          bgColor="white"
                          textColor="#5E5E5E"
                          borderRadius="8px"
                          placeholderColor="#5E5E5E"
                          lineHeight="38px"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={10} xl={10}>
                      <Form.Item
                        label="Your email"
                        name="email"
                        rules={[
                            { required: true, message: "Please enter your email" },
                            { type: "email", message: "Enter valid email" },
                            {
                              validator: validateNoWhitespace,
                            },
                        ]}
                      >
                        <CustomInput
                          placeholder="name@example.com"
                          height="36px"
                          border="0px"
                          bgColor="white"
                          textColor="#5E5E5E"
                          borderRadius="8px"
                          placeholderColor="#5E5E5E"
                          lineHeight="38px"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={20} xl={20}>
                      <Form.Item
                        label="Company name"
                        name="companyName"
                        rules={[
                          {
                            required: true,
                            message: "Please input your Company name",
                          },
                          {
                            validator: validateNoWhitespace,
                          },
                        ]}
                      >
                        <CustomInput
                          placeholder="Your company's name"
                          height="36px"
                          border="0px"
                          bgColor="white"
                          textColor="#5E5E5E"
                          borderRadius="8px"
                          placeholderColor="#5E5E5E"
                          lineHeight="38px"
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={20}
                      xl={20}
                      style={{ marginTop: "10px" }}
                    >
                      <CustomButton
                        text="Sign up for Access"
                        block="block"
                        height="48px"
                        bgColor="#000"
                        color="#fff"
                        borderRadius="8px"
                        fontSize={14}
                        fontWeight={500}
                        htmlType='submit'
                      />
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
            <Col xs={24} sm={24} lg={24} xl={14} className="hero-right">
              <div className="hero-images">
                <img src={heroImg} className="hero-img hero-img-main" alt="" />
                <img
                  src={heroImgSmall}
                  className="hero-img-sm hero-img"
                  alt=""
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <CustomModalWithoutButton
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalSize={400}
      >
        <ThankYou />
      </CustomModalWithoutButton>
    </>
  );
};

export default Hero;
